import templateUrl from './edit-commission-policy.component.html'

/**
 * A commission policy editor that determines commission calculations for commissions
 * corresponding with sales from the RS schedule.
 */
export const EditCommissionPolicyComponent = {
    require: {
        editForm: "^^form"
    },
    controller: EditCommissionPolicyController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        commissionPolicy: "<",
        programs: "<",
        retailers: "<",
        divisions: "<",
        onSave: "&",
        onDelete: "&",
        onValidate: "&",
        onEditOtherPolicy: "&",
    }
};

function EditCommissionPolicyController(commissionPolicyArchiveService) {
    'ngInject';
    const vm = this;
    vm.$onInit = $onInit;

    // Injected by directive.
    vm.commissionPolicy;
    vm.programs;
    vm.retailers;
    vm.divisions;
    vm.onDelete;
    vm.onValidate;
    vm.onEditOtherPolicy;

    vm.filterArchive = filterArchive;
    vm.filterVisibleArchive = filterVisibleArchive;
    vm.filterTier = commissionPolicyArchiveService.filterTier;

    vm.onAddArchive = onAddArchive;
    vm.onDeleteArchive = onDeleteArchive;
    vm.onArchiveChange = onArchiveChange;
    vm.onAddTier = onAddTier;
    vm.onDeleteTier = onDeleteTier;
    vm.onTierEndAmountChanged = commissionPolicyArchiveService.updateTiers;
    vm.onChangeProgram = onChangeProgram;

    function $onInit() { }

    function filterArchive(archive) {
        return !archive.IsDeleted;
    }

    function filterVisibleArchive(archive) {
        return !archive.IsNew || !archive.IsDeleted;
    }

    function onAddArchive() {
        const newArchive = commissionPolicyArchiveService.addArchive(vm.commissionPolicy);
        newArchive.isOpen = true;
        vm.commissionPolicy.ActivePolicy = getActivePolicy(vm.commissionPolicy);

        // Use the policy's currently selected program to set the division properties.
        const division = vm.commissionPolicy.Program ? vm.divisions.filter(function (division) {
            return division.Id === vm.commissionPolicy.Program.DivisionID;
        })[0] : null;
        commissionPolicyArchiveService.changeArchiveDivision(newArchive, division);

        // Add a default tier to the new archive.
        commissionPolicyArchiveService.addTier(newArchive);

        vm.editForm.$setDirty(true);
    }

    function onDeleteArchive(archive) {
        commissionPolicyArchiveService.deleteArchive(archive, function () {
            return confirm("The tiers in this date range will be deleted after you click save.");
        });

        onArchiveChange(archive);
    }

    function onArchiveChange(archive) {
        // Update each archive's conflict state, not just the one that changed.
        vm.commissionPolicy.Archives.filter(function(archive) {
            return !archive.IsDeleted;
        }).forEach(function (archive) {
            // Only propagate changes if there aren't any unresolvable active date overlaps.
            const hasConflicts = commissionPolicyArchiveService.archiveDatesOverlap(archive,
                archive.ActiveStart, archive.ActiveEnd, vm.commissionPolicy);
            //TODO: also set validity for all affected archives.
            archive.editForm.$setValidity("conflict", !hasConflicts);

            // Fill in blank active end dates that are followed by another archive.
            if (archive.ActiveStart && !hasConflicts) {
                const changes = commissionPolicyArchiveService.updateCommissionPolicyArchive(
                    vm.commissionPolicy, archive);

                //TODO: Raise a validation error for each affected archive if the change can
                // cause changes to a payroll calculation.

                changes.forEach(function (changedArchive) {
                    changedArchive.editForm.$setDirty(true);
                });
            }
        });

        // Clear any model state errors.
        vm.commissionPolicy.errorModelState = null;

        // Re-evaluate which archive is the most recent.
        vm.commissionPolicy.ActivePolicy = getActivePolicy(vm.commissionPolicy);
        vm.commissionPolicy.Archives.sort(function (a, b) {
            if (a.IsNew && !a.ActiveStart) {
                // Always return new policies with a blank start date first.
                return -1;
            }
            // Otherwise, sort descending by start date.
            return a.ActiveStart < b.ActiveStart ? 1 : -1;
        });

        // Always set the edited archive's state to dirty.
        archive.editForm.$setDirty(true);
    }

    function onAddTier(archive) {
        commissionPolicyArchiveService.addTier(archive);

        archive.editForm.$setDirty(true);
    }

    function onDeleteTier(tier, archive) {
        commissionPolicyArchiveService.deleteTier(tier, archive);

        archive.editForm.$setDirty(true);
    }

    function onChangeProgram() {
        if (vm.commissionPolicy.Program) {
            const division = vm.commissionPolicy.Program ? vm.divisions.filter(function (division) {
                return division.Id === vm.commissionPolicy.Program.DivisionID;
            })[0] : null;

            commissionPolicyArchiveService.changeCommissionPolicyDivision(vm.commissionPolicy, division);
        }

        vm.onValidate();
    }

    function getActivePolicy(commissionPolicy) {
        return commissionPolicy.Archives.reduce(function (mostRecent, archive) {
            return !archive.IsDeleted && (mostRecent === null || mostRecent.ActiveStart < archive.ActiveStart)
                ? archive
                : mostRecent;
        }, null);
    }
}
